import PageLoadErrorAlertContent from '@/components/error/PageLoadErrorAlertContent';
import { PortalPartnerLayout } from '@/components/layout/portal-partner-layout';
import { ErxStatusChip } from '@/components/prescriptions/ErxStatusChip';
import { PrescriptionActions } from '@/components/prescriptions/PrescriptionActions';
import { PrescriptionDetails } from '@/components/prescriptions/PrescriptionDetails';
import { PrescriptionQrCode } from '@/components/prescriptions/PrescriptionQrCode';
import { usePrescription } from '@/hooks/prescriptions/usePrescription';
import { PRESCRIPTIONS_ROUTE } from '@/routes/route-paths';
import { CircularProgressWrapper } from '@montugroup/circuit-shared/components/common/CircularProgressWrapper';
import { Alert, AlertTitle, Stack, Typography } from '@montugroup/design-system';
import { useMediaQuery, useTheme } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';

export function Prescription() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { state } = useLocation();
  const { id } = useParams();
  const prescriptionId = Number(id);
  const token = state.token;
  const { data, refetch, isLoading, isError } = usePrescription({ prescriptionId });
  const prescription = data?.body.data;
  const prescriptionProduct = prescription?.prescriptionProducts[0];
  const shouldShowErrorAlert = isError || !prescription;

  const handleClickRetry = () => refetch();

  if (isLoading) {
    return <CircularProgressWrapper />;
  }

  // TODO: This paddingX={3} should be handled by the `ContentWrapper` component so that each page has consistent padding
  return (
    <Stack direction={'column'} gap={isMobile ? 1 : 8} paddingX={3} flexGrow={1}>
      <PortalPartnerLayout.Back backText="Prescriptions" defaultRoute={PRESCRIPTIONS_ROUTE} />
      {shouldShowErrorAlert && (
        <Alert severity="error">
          <AlertTitle>Failed to fetch full prescriptions details</AlertTitle>
          <PageLoadErrorAlertContent onClickRetry={handleClickRetry} />
        </Alert>
      )}
      <Stack gap={isMobile ? 6 : 8}>
        <Stack direction={'column'} gap={2} alignItems={'start'}>
          {prescriptionProduct?.name && (
            <Typography variant="subtitle2" fontWeight={'600'} color="primary.main">
              {prescriptionProduct?.name}
            </Typography>
          )}
          {prescriptionProduct?.erxStatus && <ErxStatusChip status={prescriptionProduct?.erxStatus} />}
        </Stack>
        <Stack direction={isMobile ? 'column' : 'row'} gap={isMobile ? 6 : 10}>
          <PrescriptionQrCode token={token} />
          <Stack direction={'column'} flexGrow={1} gap={6}>
            <PrescriptionDetails
              token={token}
              dosageInstructions={prescriptionProduct?.dosageInstructions}
              prescribedDate={prescription?.prescribedDate}
              patientInitials={prescription?.patient?.initials}
            />
            <PrescriptionActions prescriptionId={prescriptionId} canDelete={!!prescription?.canDelete} />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
